<template>
  <div v-if="loading"><Loader /></div>

  <div v-else>
    <b-form-group v-if="districts.length > 0">
      <DistrictsSelect v-model="selectedDistrictId" :default-options="districts" />
    </b-form-group>

    <b-form-group>
      <InstitutionsSelect
        v-if="institutions.length > 0"
        :model-value="modelValue"
        :disabled="districts.length > 0 && !selectedDistrictId"
        :show-only-from-district="selectedDistrictId"
        :default-options="institutions"
        :show-placeholder="false"
        :max-height="500"
        :show-all="true"
        :disable-self-fetch="true"
        @update:model-value="(value) => emit('update:modelValue', value)"
      />

      <b-alert v-else :model-value="true" variant="warning" class="mb-0">
        {{ $t("No institutions are currently available.") }}
      </b-alert>
    </b-form-group>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import InstitutionsSelect from "@/modules/institutions/components/InstitutionsSelect.vue";
import DistrictsSelect from "@/modules/districts/components/DistrictsSelect.vue";
import Loader from "@/components/Loader.vue";
import { useDistrictsOptions } from "@/composables/data/useDistrictsOptions";

const props = defineProps<{
  modelValue: number | undefined | null;
  registrationUserType: "parent" | "institution_worker";
}>();

const emit = defineEmits<{
  "update:modelValue": [value: number | undefined];
}>();

const store = useStore();

const { districts } = useDistrictsOptions();
const selectedDistrictId = ref<number>();

type InstitutionOption = { value: number; text: string };

const institutions = ref<InstitutionOption[]>([]);
const loading = ref(false);

onMounted(async () => {
  loading.value = true;

  try {
    const action =
      props.registrationUserType === "institution_worker"
        ? "auth/getInstitutionWorkerRegisterOptions"
        : "auth/getChildRegisterOptions";

    const result = await store.dispatch(action, null);
    institutions.value = result.institutionsOptions ?? [];
  } finally {
    loading.value = false;
  }
});
</script>
